import { ActionReducerMap } from '@ngrx/store';
import { AppState } from './app-state.type';
import { CountriesReducer } from './countries/countries.reducer';
import { DocumentIdReducer } from './document-id/document-id.reducer';
import { EnumsReducer } from './enumeration/enumeration.reducer';
import { FeeQuoteReducer } from './fee-quote/fee-quote.reducer';
import { LabelsReducer } from './labels/labels.reducer';
import { LocationReducer } from './locations/location.reducer';
import { QueryParamsReducer } from './query-params/query-param.reducer';
import { ServiceOptionsReducer } from './service-options/service-options.reducer';
import { StatesReducer } from './states/states.reducer';
import { TransactionReducer } from './transaction/transaction.reducer';

export const reducers: ActionReducerMap<AppState> = {
  transactionState: TransactionReducer,
  queryParamsState: QueryParamsReducer,
  enumsState: EnumsReducer,
  documentState: DocumentIdReducer,
  serviceOptionsState: ServiceOptionsReducer,
  labelsState: LabelsReducer,
  countriesState: CountriesReducer,
  statesState: StatesReducer,
  feeQuoteState: FeeQuoteReducer,
  locationState: LocationReducer,
};
